import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCursor1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cursor-1, arrow"><path d="M4.25412 2.65459C3.25895 2.2963 2.2963 3.25895 2.65459 4.25412L8.78642 21.2856C9.17367 22.3612 10.6822 22.3956 11.1181 21.3388L14.1025 14.1025L21.3388 11.1181C22.3956 10.6822 22.3612 9.17367 21.2856 8.78642L4.25412 2.65459Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCursor1;
